import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import Processo from '../interfaces/Processo';

class ProcessoController {

  public static async getProcessosGestor(
    showLoading = true,
  ): Promise<Processo[]> {
    const user: User = store.getters.user;
    const nrOrg = user.nrorg;
    const nrParcNegocio = user.nrparcnegocio;

    const route = 'getProcessosGestor';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRPARCNEGOCIO: nrParcNegocio,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const processos: any[] = response.data.dataset.data;

      return processos;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error :
      'Não foi possível carregar os processos de seleção!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getFasesTemplate(
    nrTemplate: string,
    showLoading = true,
  ): Promise<any[]> {
    const user: User = store.getters.user;
    const nrOrg = user.nrorg;

    const route = 'getFasesTemplate';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRTEMPLATE: nrTemplate,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const fases: any[] = response.data.dataset.data;

      return fases;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error :
      'Não foi possível carregar as fases do processo!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getCandidatosFase(
    nrProcesso: string,
    nrFase: string,
    showLoading = true,
  ): Promise<any[]> {
    const user: User = store.getters.user;
    const nrOrg = user.nrorg;

    const route = 'getCandidatosFase';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRPROCESSO: nrProcesso,
      NRFASE: nrFase,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const candidatos: any[] = response.data.dataset.data;

      return candidatos;

    } catch (err) {
      const message = err && (err as any).response ? (err as any).response.data.error :
      'Não foi possível carregar os candidatos!';

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async generateResume(
    nrOrg: string,
    nrParcNegocio: string,
    showLoading = true,
  ): Promise<string> {
    const route = 'generateResume';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRPARCNEGOCIO: nrParcNegocio,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const link: string = response.data.dataset.data.link;
      return link;
    } catch (err) {
      let message = 'Não foi possível gerar o currículo!';

      if (err instanceof Error) {
        message = ExpectedError.getResponseErrorMessage(err, message);
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async getCandidatosGeral(
    row: any,
    showLoading = true,
  ): Promise<any[]> {
    const route = 'getCandidatosGeral';

    const user: User = store.getters.user;
    const nrOrg = user.nrorg;

    const params = {
      requestType: 'FilterData',
      ...row,
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      ExpectedError.throwResponseError(response);

      const candidatos: any[] = response.data.dataset.data;
      return candidatos;
    } catch (err) {
      let message = 'Não foi possível gerar os candidatos!';

      if (err instanceof Error) {
        message = ExpectedError.getResponseErrorMessage(err, message);
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async addCandidatos(
    nrProcesso: string,
    candidatos: any[],
    showLoading = true,
  ): Promise<void> {
    const route = 'addCandidatos';

    const user: User = store.getters.user;
    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const params = {
      requestType: 'Row',
      row: {
        NRORG: nrOrg,
        CDOPERADOR: cdOperador,
        NRPROCESSO: nrProcesso,
        candidatos,
      }
    };

    try {
      const response = await HttpRequest.post(route, params, showLoading);
      ExpectedError.throwResponseError(response);
    } catch (err) {
      let message = 'Não foi possível adicionar os candidatos!';

      if (err instanceof Error) {
        message = ExpectedError.getErrorMessage(err, message);
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }
}

export default ProcessoController;
